"use client"

import { router, usePage } from "@inertiajs/react"
import { SearchLg } from "@untitledui/icons"
import type { PropsWithChildren } from "react"

import { Input } from "@/components/ui/input"
import { NativeSelect } from "@/components/ui/select"
import { TabList, Tabs } from "@/components/ui/tabs"
import { DashboardLayout } from "@/layouts/dashboard-layout"

const tabs = [
  { id: "profile", label: "Profile" },
  { id: "password", label: "Password" },
  { id: "appearance", label: "Appearance" },
  { id: "email", label: "Email" },
  { id: "sessions", label: "Sessions" },
]

export default function SettingsLayout({ children }: PropsWithChildren) {
  const { url } = usePage()

  // Extract the current tab from the URL
  // e.g. /settings/profile -> profile
  const currentTab = url.split("/").pop() ?? "profile"

  const handleTabChange = (key: React.Key) => {
    router.visit(`/settings/${key}`)
  }

  return (
    <DashboardLayout>
      <div className="flex flex-col gap-8 pt-8 pb-12">
        <div className="flex flex-col gap-5 px-4 lg:px-8">
          {/* Page header simple with search */}
          <div className="relative flex flex-col gap-5">
            <div className="flex flex-col gap-4 lg:flex-row lg:justify-between">
              <div className="flex flex-col gap-0.5 lg:gap-1">
                <h1 className="text-primary lg:text-display-xs text-xl font-semibold">
                  Settings
                </h1>
              </div>
              <div className="flex flex-col gap-4 lg:flex-row">
                <Input
                  className="lg:w-80"
                  size="sm"
                  shortcut
                  aria-label="Search"
                  placeholder="Search"
                  icon={SearchLg}
                />
              </div>
            </div>
          </div>

          <NativeSelect
            aria-label="Page tabs"
            className="md:hidden"
            value={currentTab}
            onChange={(event) => handleTabChange(event.target.value)}
            options={tabs.map((tab) => ({ label: tab.label, value: tab.id }))}
          />
          <div className="scrollbar-hide -mx-4 -my-1 flex overflow-auto px-4 py-1 lg:-mx-8 lg:px-8">
            <Tabs
              className="hidden md:flex xl:w-full"
              selectedKey={currentTab}
              onSelectionChange={handleTabChange}
            >
              <TabList type="button-minimal" className="w-full" items={tabs} />
            </Tabs>
          </div>
        </div>

        {children}
      </div>
    </DashboardLayout>
  )
}
